import { default as baseTheme } from './base'
import { createTheme } from '@mui/material/styles'

// ----------------------------------------
// Brand Color
// ----------------------------------------
const brandColorSet = {
  main: '#ffb751',
  light: '#fff3e2',
  dark: '#ff8d24',
  contrastText: '#fff'
}

const theme = createTheme(baseTheme, {
  palette: {
    type: 'light',
    brand: brandColorSet
  }
})

export default theme
